import loginService from '@/api/auth.service'
import { setAxiosDefaultHeaders } from '../../../utils/axios'

const actions = {
  authenticate: (context, loginModel) => {
    return new Promise((resolve, reject) => {
      loginService
        .postLogin(context, loginModel)
        .then(response => {
          context.commit('authenticate', response)
          context.commit('setUserInfo', {
            userEmail: loginModel.Username,
            userType: response.userType,
            token: response.verification_token
          })
          localStorage.setItem('_verificationToken', response.verification_token)
          localStorage.setItem('userType', response.userType)
          localStorage.setItem('userEmail', loginModel.Username)
          setAxiosDefaultHeaders()
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  authenticateFromToken: (context, token) => {
    return new Promise((resolve, reject) => {
      context.commit('authenticateFromToken', token)
    })
  },
  logOut(context) {
    const promise = new Promise((resolve, reject) => {
      loginService
        .logOut(context)
        .then(response => {
          context.commit('unauth')
          context.commit('setUserInfo', null)
          // localStorage.clear()
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return promise
  },
  sendForgotPasswordMail: (context, forgotPasswordModel) => {
    let mailSent = new Promise((resolve, reject) => {
      loginService
        .postForgotPassword(context, forgotPasswordModel)
        .then(response => {
          context.commit('sendForgotPasswordMail', response)
          resolve(response)
        })
        .catch(err => reject(err))
    })
    return mailSent
  },
  forgotPasswordMailSent: (context, payload) => {
    context.commit('isForgotPasswordMailSent', payload)
  },
  sendNewPasswordInfo: (context, data) => {
    let passwordSent = new Promise((resolve, reject) => {
      loginService
        .postNewPassword(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
    return passwordSent
  }
}
export default actions
